import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BASE_LABELS = {
    renovation_legere: "Rénovation légère",
    renovation_partielle: "Rénovation partielle",
    renovation_complete: "Rénovation complète",
    renovation_lourde: "Rénovation lourde",
    construction_standard: "Construction standard",
    construction_haut_gamme: "Construction haut de gamme",
    construction_luxe: "Construction luxe",
};

const FINISH_LABELS = { essentiel: "Essentiel", confort: "Confort", prestige: "Prestige" };

export const AdminPricing = () => {
    const [pricing, setPricing] = useState(null);
    const [busy, setBusy] = useState(false);
    const [showLots, setShowLots] = useState(false);

    useEffect(() => {
        axios.get(`${API}/admin/pricing`).then((r) => setPricing(r.data)).catch(() => {});
    }, []);

    if (!pricing) return <p className="text-[13px] text-[#1C1E1D]/50 italic">Chargement…</p>;

    const save = async () => {
        setBusy(true);
        try {
            const r = await axios.put(`${API}/admin/pricing`, {
                base_prices: pricing.base_prices,
                finish_multipliers: pricing.finish_multipliers,
                lot_prices: pricing.lot_prices,
            });
            setPricing(r.data);
            toast.success("Prix enregistrés — appliqués immédiatement aux devis");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Erreur d'enregistrement");
        } finally {
            setBusy(false);
        }
    };

    const setBase = (k, v) => setPricing((p) => ({ ...p, base_prices: { ...p.base_prices, [k]: v } }));
    const setFinish = (k, v) => setPricing((p) => ({ ...p, finish_multipliers: { ...p.finish_multipliers, [k]: v } }));
    const setLot = (k, i, v) => setPricing((p) => {
        const lot = [...p.lot_prices[k]];
        lot[i] = v;
        return { ...p, lot_prices: { ...p.lot_prices, [k]: lot } };
    });

    return (
        <div className="space-y-6">
            <div className="lux-card p-6">
                <div className="tracking-luxe text-[#B89C6A] mb-4">Prix de base €/m² — Simulateur de devis</div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                    {Object.keys(BASE_LABELS).map((k) => (
                        <label key={k} className="text-[11px] tracking-wider uppercase text-[#1C1E1D]/60">
                            {BASE_LABELS[k]}
                            <input
                                data-testid={`pricing-base-${k}`}
                                type="number" min="100" step="50"
                                className="lux-input mt-1 w-full"
                                value={pricing.base_prices[k]}
                                onChange={(e) => setBase(k, Number(e.target.value))}
                            />
                        </label>
                    ))}
                </div>
            </div>

            <div className="lux-card p-6">
                <div className="tracking-luxe text-[#B89C6A] mb-4">Multiplicateurs de finition</div>
                <div className="grid grid-cols-3 gap-3">
                    {Object.keys(FINISH_LABELS).map((k) => (
                        <label key={k} className="text-[11px] tracking-wider uppercase text-[#1C1E1D]/60">
                            {FINISH_LABELS[k]}
                            <input
                                data-testid={`pricing-finish-${k}`}
                                type="number" min="0.5" max="3" step="0.01"
                                className="lux-input mt-1 w-full"
                                value={pricing.finish_multipliers[k]}
                                onChange={(e) => setFinish(k, Number(e.target.value))}
                            />
                        </label>
                    ))}
                </div>
            </div>

            <div className="lux-card p-6">
                <button
                    data-testid="pricing-toggle-lots"
                    onClick={() => setShowLots((s) => !s)}
                    className="tracking-luxe text-[#B89C6A] flex items-center gap-2"
                >
                    Prix par lot €/m² (min — max) — Estimateur IA {showLots ? "▲" : "▼"}
                </button>
                {showLots && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4">
                        {Object.keys(pricing.lot_prices).map((k) => (
                            <div key={k} className="flex items-center gap-2">
                                <span className="text-[11px] tracking-wider uppercase text-[#1C1E1D]/60 flex-1 capitalize">{k.replace(/_/g, " ")}</span>
                                <input type="number" min="1" className="lux-input w-24" value={pricing.lot_prices[k][0]}
                                    onChange={(e) => setLot(k, 0, Number(e.target.value))} />
                                <span className="text-[#B89C6A]">—</span>
                                <input type="number" min="1" className="lux-input w-24" value={pricing.lot_prices[k][1]}
                                    onChange={(e) => setLot(k, 1, Number(e.target.value))} />
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <button data-testid="pricing-save" onClick={save} disabled={busy} className="btn-champagne disabled:opacity-50">
                {busy ? "Enregistrement…" : "Enregistrer les prix"}
            </button>
        </div>
    );
};
